/* =========================================================
   Plantive Style Policy Section - JS (Scrollspy Only)
========================================================= */

(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Smooth Scroll & Active Pill Sync ---
  const navPills = document.querySelectorAll('.plc-nav-pill');
  const sections = document.querySelectorAll('[data-nav-section]');

  // Click to scroll
  navPills.forEach(pill => {
    pill.addEventListener('click', (e) => {
      e.preventDefault();
      const id = pill.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      
      if(target) {
        const y = target.getBoundingClientRect().top + window.scrollY - 70; // offset for sticky nav
        window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    });
  });

  // Scrollspy (Highlight active nav based on scroll position)
  const setActiveLink = (sectionId) => {
    navPills.forEach(pill => {
      if (pill.getAttribute('href') === `#${sectionId}`) {
        pill.classList.add('is-active');
        // Center active pill in mobile scroll view
        pill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        pill.classList.remove('is-active');
      }
    });
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(entry => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

      if (visible) setActiveLink(visible.target.id);
    }, {
      rootMargin: "-20% 0px -60% 0px",
      threshold: [0, 0.1, 0.25]
    });

    sections.forEach(section => observer.observe(section));
  }
})();